import { useQuery } from '@tanstack/react-query';
import { ROUTES, type FinRecord } from '@serb/shared';
import { api } from '../../api/client';
import { KEYS } from '../../api/keys';
import { SAMPLE_DATA } from '../../lib/sample';
import { SHIPMENTS } from '../shipments/sample';
import { useShipments } from '../shipments/useShipments';
import { financials, type Fin } from './calc';
import { FINANCE } from './sample';

/** Every won shipment's money, worked out: read from the Serb Mind vault (the sample figures only while sample data is on) */
export function useFinance(): Fin[] {
  const { items: ships } = useShipments();
  const q = useQuery({ queryKey: KEYS.finance, queryFn: () => api.get<FinRecord[]>(ROUTES.api.finance) });
  if (SAMPLE_DATA) return FINANCE.map((r) => financials(r, SHIPMENTS));
  return (q.data ?? []).map((r) => financials(r, ships));
}
